module.exports = __webpack_public_path__ + "static/media/swap-darkmode.8c6d7a28.svg";